import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import theme from './VideoSidebarEmptyPlaceholder.scss';

const VideoSidebarEmptyPlaceholder = () => (
  <div className={ theme.root }>
    <FormattedHTMLMessage
      id="schedule.videoSidebarEmptyPlaceholder.message"
      defaultMessage="** Click on an appointment for more details"
    />
  </div>
);

export default VideoSidebarEmptyPlaceholder;
